export enum ECampaignsActions {
  LOAD_CAMPAIGNS = '[Campaigns] Load Campaigns',
  LOAD_CAMPAIGNS_SUCCESS = '[Campaigns] Load Campaigns Success',
  LOAD_CAMPAIGNS_ERROR = '[Campaigns] Load Campaigns Error',
  CHANGE_PAGE = '[Campaigns] Change Page',
  CHANGE_PAGE_SUCCESS = '[Campaigns] Change Page Success',
  CHANGE_PAGE_ERROR = '[Campaigns] Change Page Error',
  UPDATE_CAMPAIGN = '[Campaign] Update Campaign',
  UPDATE_CAMPAIGN_SUCCESS = '[Campaign] Update Campaign Success',
  UPDATE_CAMPAIGN_ERROR = '[Campaign] Update Campaign Error',
  REFRESH_CAMPAIGNS = '[Campaign] Refresh Campaigns',
  GET_CAMPAIGN_INFO = '[Campaign] Get Campaign Info',
  GET_CAMPAIGN_INFO_SUCCESS = '[Campaign] Get Campaign Info Success',
  GET_CAMPAIGN_INFO_ERROR = '[Campaign] Get Campaign Info Error',
  CREATE_CAMPAIGN = '[Campaign] Create Campaign',
  CREATE_CAMPAIGN_SUCCESS = '[Campaign] Create Campaign Success',
  CREATE_CAMPAIGN_ERROR = '[Campaign] Create Campaign Error',
  DELETE_CAMPAIGN = '[Campaign] Delelete Campaign',
  DELETE_CAMPAIGN_SUCCESS = '[Campaign] Delelete Campaign Success',
  DELETE_CAMPAIGN_ERROR = '[Campaign] Delelete Campaign Error',
  RESTORE_CAMPAIGN = '[Campaign] Restore Campaign',
  RESTORE_CAMPAIGN_SUCCESS = '[Campaign] Restore Campaign Success',
  RESTORE_CAMPAIGN_ERROR = '[Campaign] Restore Campaign Error',
  LOAD_BLOCKED_DATES = '[Blocked Dates] Load Blocked Dates',
  LOAD_BLOCKED_DATES_SUCCESS = '[Blocked Dates] Load Dates Success',
  LOAD_BLOCKED_DATES_ERROR = '[Blocked Dates] Load Dates Error',
  CREATE_DATE = '[Blocked Dates] Create Date',
  CREATE_DATE_SUCCESS = '[Blocked Dates] Create Date Success',
  CREATE_DATE_ERROR = '[Blocked Dates] Create Date Error',
  DELETE_DATE = '[Blocked Dates] Delelete Date',
  DELETE_DATE_SUCCESS = '[Blocked Dates] Delelete Date Success',
  DELETE_DATE_ERROR = '[Blocked Dates] Delelete Date Error',
  REFRESH_DATES = '[Blocked Dates] Refresh Dates',
  CHANGE_DATES_PAGE = '[Blocked Dates] Change Dates Page',
  CHANGE_DATES_PAGE_SUCCESS = '[Blocked Dates] Change Dates Page Success',
  CHANGE_DATES_PAGE_ERROR = '[Blocked Dates] Change Dates Page Error',
}

export enum ECampaignType {
  STANDARD = 'Standard',
  FREQUENCY = 'Frequency',
}

export interface ICampaign {
  campaign_id: number;
  campaign_name?: string;
  campaign_type?: ECampaignType;
  campaign_deleted?: boolean;
  campaign_active?: boolean;
  campaign_frequency?: number;
  campaign_published_state?: boolean;
  account_id?: number;
  account_firstname?: string;
  account_lastname?: string;
  account_email?: string;
  scheduled_emails?: any;
  scheduled_date?: string;
  campaign_attention?: string;
  campaign_details?: string;
  campaign_goal?: string;
  campaign_greeting?: string;
  campaign_sign?: string;
  first_benefit?: string;
  quick_answer?: string;
  second_benefit?: string;
  third_benefit?: string;
  campaign_group_id?: number;
  active_state?: boolean;
  campaign_progress?: number;
  content_group_id?: number;
  content_requested?: boolean;
  content_group?: string;
  published_state?: boolean;
}

export enum ECampaignGoal {
  PHONE = 'phone',
  OTHER = 'other',
  MEETING = 'meeting',
  FACE = 'face',
}

export enum ECampaignStateStatus {
  INITIALIZING = 'initializing',
  LOADING = 'loading',
  READY = 'ready',
  ERROR = 'error',
  UPDATED = 'updated',
  CRATED = 'created',
}

export enum ECampaignPaginationType {
  ACTIVE = 'active_campaigns',
  PENDING = 'pending_campaigns',
  DELETED = 'deleted_campaigns',
}

export interface ICampaignPagination {
  current_page?: number;
  has_more_data?: boolean;
  page_size?: number;
  total_pages_count?: number;
  has_previous?: boolean;
  total_count?: number;
  type?: ECampaignPaginationType;
  count?: number;
}

export interface ICampaignListingPagination {
  active_campaigns: ICampaignPagination;
  pending_campaigns: ICampaignPagination;
  deleted_campaigns: ICampaignPagination;
}

export interface ICampaignState {
  status: ECampaignStateStatus;
  active_campaigns: ICampaign[];
  pending_campaigns: ICampaign[];
  deleted_campaigns: ICampaign[];
  pagination: ICampaignListingPagination;
  currentCampaign?: ICampaign;
  new_campaign_id?: number;
  error: any;
  update_response?: any;
}

export enum ECampaignCreateState {
  EDIT = 'edit',
  CREATE = 'create',
}

export interface IDatesPagination {
  current_page: number;
  has_more_data?: boolean;
  page_size: number;
  total_pages_count?: number;
  has_previous?: boolean;
  total_count?: number;
}

export interface IDates {
  item: string;
}

export interface IBlockedDatesState {
  status: EBlockedDatesStateStatus;
  items: IDates[];
  pagination: IDatesPagination;
  currentDate?: IDates;
  new_date_id?: number;
  error: any;
  update_response?: any;
}

export enum EBlockedDatesStateStatus {
  INITIALIZING = 'initializing',
  LOADING = 'loading',
  READY = 'ready',
  ERROR = 'error',
  UPDATED = 'updated',
  CRATED = 'created',
}

export interface IDatesState {
  status: EBlockedDatesStateStatus;
  items: IDates[];
  pagination: IDatesPagination;
  currentDate?: IDates;
  new_date_id?: number;
  error: any;
  update_response?: any;
  extra_data?: string[];
}

export interface IBlockedDateRule {
  blockType: string[];
  managers: number[];
  partners: number[];
  states: string[];
  timezones: string[];
}

export interface IBlockedDateRules {
  created_at: string;
  created_by: number;
  date_id: number;
  id: number;
  rule: IBlockedDateRule;
  updated_at: string;
}

export interface IBlockedDate {
  id: number;
  account_id: number;
  blockedRules: IBlockedDateRules[];
  blocked_by: string;
  block_date: string;
}
